// extracted by mini-css-extract-plugin
module.exports = {"root":"_2GMhavrw8VK2"};